import actions from './authActions'

export default {
  namespaced: true,
  actions
}